import { WordingMultiFitnessYogaPilates } from '@/types';

export const MULTI_FITNESS_YOGA_PILATES_WORDING_BG: WordingMultiFitnessYogaPilates = {
  components_header_media_content: 'Фитнес',
  components_header_media_1: 'За мъже',
  components_header_media_2: 'За жени',
  components_header_media_multi_content_2: 'Йога',
  components_header_media_multi_content_3: 'Пилатес',
  hero_text: 'Тренирайте по-умно, чувствайте се по-добре.',
  hero_button_text: 'Започнете сега',
  components_ressources_subheader_text: 'Ръководства и съвети',
  components_ressources_span_text: 'Той съчетава земния фокус на йога, контролираната прецизност на пилатес и динамичното предизвикателство на силовите тренировки, за да подпомогне един добре балансиран и здравословен начин на живот.',
  components_ressources_card_1_title: 'Съвети за йога',
  components_ressources_card_1_text: 'Кратко ръководство за по-добър баланс, дишане и поток.',
  components_ressources_card_2_title: 'Съвети за пилатес',
  components_ressources_card_2_text: 'Прости съвети за укрепване на мускулите на торса и подобряване на контрола.',
  components_notes_and_google_title_1: 'Изграждане на сила',
  components_notes_and_google_title_2: 'Йога Спокойствие',
  components_notes_and_google_title_3: 'Пилатес кор',
  media_content_section_multi_1_subheader_text: 'Обучителни видеоклипове',
  media_content_section_multi_2_subheader_text: 'Йога видеоклипове',
  media_content_section_multi_3_subheader_text: 'Видеоклипове за пилатес',
  text_media_1: 'Мъже',
  text_media_2: 'Жени',
  page_media_content_menu_biceps: 'Бицепси',
  page_media_content_menu_triceps: 'Трицепс',
  page_media_content_menu_back: 'Обратно',
  page_media_content_menu_chest: 'Гръден кош',
  page_media_content_menu_legs: 'Крака',
  page_media_content_menu_shoulders: 'Рамене',
  page_media_content_menu_abdominals: 'Коремни мускули',
  components_text1_subheader_text: 'Здравословна диета за вашия активен живот',
  components_text1_span_text: 'Здравословни рецепти, които подпомагат тренировките ви и подобряват благосъстоянието ви.',
  components_footer_text: 'Укрепете тялото си, балансирайте ума си и се движете със смисъл – вашето място за фитнес, йога и пилатес.',
};